import React, { createElement } from 'react';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
import { useVideos, Video } from './VideosContext';
interface DeleteVideoConfirmationProps {
  video: Video;
  onClose: () => void;
}
export function DeleteVideoConfirmation({
  video,
  onClose
}: DeleteVideoConfirmationProps) {
  const {
    deleteVideo
  } = useVideos();
  const handleDelete = () => {
    deleteVideo(video.id);
    // Show success notification
    const notification = document.createElement('div');
    notification.className = 'fixed top-24 right-1/2 transform translate-x-1/2 bg-green-100 text-green-800 px-4 py-2 rounded-full shadow-lg z-50 animate-fadeIn';
    notification.textContent = 'تم حذف الفيديو بنجاح';
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.classList.add('opacity-0');
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 2000);
    onClose();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-805">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-806">
        <div className="p-4 bg-rose-50 border-b border-rose-100 flex justify-between items-center" data-id="element-807">
          <h3 className="font-bold text-rose-900" data-id="element-808">تأكيد الحذف</h3>
          <button onClick={onClose} className="p-1.5 rounded-full hover:bg-rose-100 text-slate-500 hover:text-slate-700 transition-colors" data-id="element-809">
            <XIcon className="h-5 w-5" data-id="element-810" />
          </button>
        </div>
        <div className="p-6" data-id="element-811">
          <div className="flex items-center justify-center mb-4" data-id="element-812">
            <div className="bg-rose-100 rounded-full p-3" data-id="element-813">
              <AlertTriangleIcon className="h-6 w-6 text-rose-600" data-id="element-814" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-center mb-2" data-id="element-815">
            هل أنت متأكد من حذف هذا الفيديو؟
          </h3>
          <p className="text-slate-600 text-center mb-4" data-id="element-816">
            سيتم حذف الفيديو "{video.title}" نهائياً. لا يمكن التراجع عن هذا
            الإجراء.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-6" data-id="element-817">
            <button onClick={onClose} className="flex-1 py-2 px-4 rounded-md font-medium bg-slate-100 hover:bg-slate-200 text-slate-700 transition-colors duration-200" data-id="element-818">
              إلغاء
            </button>
            <button onClick={handleDelete} className="flex-1 py-2 px-4 rounded-md font-medium bg-rose-600 hover:bg-rose-700 text-white transition-colors duration-200" data-id="element-819">
              نعم، احذف الفيديو
            </button>
          </div>
        </div>
      </div>
    </div>;
}